import {Routes} from '@angular/router';
import {IndexComponent as PatientsIndexComponent} from './index/index.component';
import {EditComponent as PatientsEditComponent} from './edit/edit.component';
import {DocumentsComponent as PatientsDocumentsComponent} from './documents/documents.component';
import {EmailsComponent as PatientsEmailsComponent} from './emails/emails.component';
import {canActivateGuard} from '../../guards/can-activate-guard';
import {PERMISSION} from '@generated-backend-types';
import {AuthenticationAuditLogComponent as PatientsAuthenticationAuditLogComponent} from './authentication-audit-log/authentication-audit-log.component';
import {PatientService} from '../../services/api/patients/patient.service';

export const routes: Routes = [
  {
    path: '',
    component: PatientsIndexComponent,
    canActivate: [canActivateGuard],
    data: {
      allPermissionsNeeded: [PERMISSION.PATIENT_READ_ALL],
      breadcrumb: [
        {
          label: 'authenticated.patients.index.breadcrumb',
          translate: true,
          route: '/patients'
        },
      ]
    }
  },
  {
    path: ':id',
    component: PatientsEditComponent,
    canActivate: [canActivateGuard],
    resolve: {
      patient: PatientService,
    },
    data: {
      allPermissionsNeeded: [PERMISSION.PATIENT_UPDATE_ALL],
      breadcrumb: [
        {
          label: 'authenticated.patients.index.breadcrumb',
          translate: true,
          route: '/patients'
        },
        {dynamic: true, dataKey: 'patient.email', route: '/patients/:id'},
        {label: 'authenticated.patients.edit.breadcrumb', translate: true,},
      ]
    }
  },
  {
    path: ':id/documents',
    component: PatientsDocumentsComponent,
    canActivate: [canActivateGuard],
    resolve: {
      patient: PatientService,
    },
    data: {
      allPermissionsNeeded: [PERMISSION.PATIENT_UPDATE_ALL],
      breadcrumb: [
        {
          label: 'authenticated.patients.index.breadcrumb',
          translate: true,
          route: '/patients'
        },
        {dynamic: true, dataKey: 'patient.email', route: '/patients/:id'},
        {label: 'authenticated.patients.documents.breadcrumb', translate: true,},
      ]
    }
  },
  {
    path: ':id/emails',
    component: PatientsEmailsComponent,
    canActivate: [canActivateGuard],
    resolve: {
      patient: PatientService,
    },
    data: {
      allPermissionsNeeded: [PERMISSION.PATIENT_READ_ALL, PERMISSION.SENTEMAIL_READ_ALL],
      breadcrumb: [
        {
          label: 'authenticated.patients.index.breadcrumb',
          translate: true,
          route: '/patients'
        },
        {dynamic: true, dataKey: 'patient.email', route: '/patients/:id'},
        {label: 'authenticated.patients.emails.breadcrumb', translate: true,},
      ]
    }
  },
  {
    path: ':id/history',
    component: PatientsAuthenticationAuditLogComponent,
    canActivate: [canActivateGuard],
    resolve: {
      patient: PatientService,
    },
    data: {
      allPermissionsNeeded: [PERMISSION.PATIENT_READ_ALL, PERMISSION.PATIENTAUTHENTICATIONAUDIT_READ_ALL],
      breadcrumb: [
        {
          label: 'authenticated.patients.index.breadcrumb',
          translate: true,
          route: '/patients'
        },
        {dynamic: true, dataKey: 'patient.email', route: '/patients/:id'},
        {label: 'authenticated.patients.history.breadcrumb', translate: true,},
      ]
    }
  }
];
